import React, { useState, useRef, useEffect, Fragment } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import MenuItem from "@material-ui/core/MenuItem";

import MakeAPICall from "../../apiCalls/common";

import Loader from "../../components/loader";
import ICInput from "../../components/form/input";
import ICCheckbox from "../../components/form/checkbox";
import Model from "../../components/modal";
import SearchInput from "../../components/searchInput";
import Label from "../../components/label";

import {
  DrugListDialog,
  RestrictionListView
} from "../../containers/DrugDatabase";

import {
  accessMIMSTokenApiRoute,
  getProductsByIngredientApiRoute,
  getProductsByBrandApiRoute,
  getDrugProductDetailsByIdApiRoute,
  getDrugPBSDetailsByPBSCodeApiRoute
} from "../../apiRoutes";

import {
  extemporaneousDrugList,
  S4DisabledDrugList,
  S4WarningDrugList,
  // multipleBrandNameDrugList,
  discontinuedDrugList,
  isotretinoinDrugList,
  inPersonGPDrugList,
  APSPrescriberDrugList,
  covid19BlockedDrugList,
  irregularQtyDrugList,
  outOfStockDrugError
} from "../../constants/drugConstants";

import * as MIMSUtils from "../../utils/MIMSUtils";

import * as _ from "lodash";

let MIMSToken = "";
let MIMSTokenExpiryTimestamp = "";
let prescriptionDataCache = {};

const DrugDatabasePage = () => {
  const drugdbInputRef = useRef();
  const drugListRef = useRef(null);

  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [showTextModal, setShowTextModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const [drugList, setDrugList] = useState([]);
  const [isShowDrugList, setIsShowDrugList] = useState(false);

  const [isDrugManuallyInput, setIsDrugManuallyInput] = useState(false);
  const [isDrugPrefilled, setIsDrugPrefilled] = useState(false);
  const [isManuallyEnterQty, setIsManuallyEnterQty] = useState(false);
  const [selectedDrug, setSelectedDrug] = useState({});

  const [isPoisonClassS8, setIsPoisonClassS8] = useState(false);
  const [isExtemporaneousDrug, setIsExtemporaneousDrug] = useState(false);
  const [specialDrugType, setSpecialDrugType] = useState("");
  const [blockedPBSType, setBlockedPBSType] = useState("");

  const [routeAdministration, setRouteAdministration] = useState("");
  const [moleculeName, setMoleculeName] = useState("");
  const [medQuantityCopy, setMedQuantityCopy] = useState("");
  const [minMedQuantity, setMinMedQuantity] = useState("");
  const [medQuantitySelect, setMedQuantitySelect] = useState([]);
  const [
    medQuantitySelectWithManualInput,
    setMedQuantitySelectWithManualInput
  ] = useState([]);

  const [PBSCodeSelect, setPBSCodeSelect] = useState([]);
  const [PBSCodeForErx, setPBSCodeForErx] = useState("");
  const [RPBS, setRPBS] = useState(false);
  const [RPBSPrefilled, setRPBSPrefilled] = useState(false);
  const [PBSPrefilled, setPBSPrefilled] = useState(false);
  const [maxNumberOfRepeats, setMaxNumberOfRepeats] = useState(99999999);
  const [maxQtyUnits, setMaxQtyUnits] = useState("");
  const [
    medQuantitySelectFromPBSDetails,
    setMedQuantitySelectFromPBSDetails
  ] = useState([]);
  const [APN, setAPN] = useState("");
  const [isAPNRequired, setIsAPNRequired] = useState(false);
  const [SAC, setSAC] = useState("");
  const [SACSelect, setSACSelect] = useState([]);
  const [authorityRequiredPBS, setAuthorityRequiredPBS] = useState(false);
  const [restrictionList, setRestrictionList] = useState([]);
  const [maxQuantityOfMed, setMaxQuantityOfMed] = useState(99999999);
  const [
    medQuantitySelectOnMaxQtyUnits,
    setMedQuantitySelectOnMaxQtyUnits
  ] = useState([]);
  const [isDiscontinuedDrug, setIsDiscontinuedDrug] = useState(false);
  const [AIPStatus, setAIPStatus] = useState("NONE");
  const [brandName, setBrandName] = useState("");
  const [ingredient, setIngredient] = useState("");
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [isIsotretinoinDrugList, setIsIsotretinoinDrugList] = useState(false);
  const [isInPersonGPDrugList, setIsInPersonGPDrugList] = useState(false);
  const [isCOVID19BlockedDrugList, setIsCOVID19BlockedDrugList] = useState(false);
  const [isIrregularQtyDrugList, setIsIrregularQtyDrugList] = useState(false);
  const [isOutOfStockDrug, setIsOutOfStockDrug] = useState('');

  const formik = useFormik({
    initialValues: {
      drugdata: "",
      PBS: false,
      brandSubstitution: false,
      pbsCode: "",
      pbsManuCode: "",
      authorityRequiredPBS: false,
      SAC: "",
      APN: "",
      drugName: "",
      strength: "",
      formType: "",
      medQuantity: "",
      numberOfRepeat: 0,
      isIncludeBrandName: false
    },
    validationSchema: Yup.object({
      drugdata: Yup.string()
        .trim()
        .required("This field is required"),
      PBS: Yup.boolean(),
      brandSubstitution: Yup.boolean(),
      pbsManuCode: Yup.string(),
      pbsCode: Yup.string(),
      drugName: Yup.string(),
      strength: Yup.string(),
      formType: Yup.string(),
      medQuantity: Yup.string(),
      numberOfRepeat: Yup.number()
    }),
    onSubmit: values => {
      // console.log(values);
    }
  });

  // the first param must be an object rather than a normal variable, as a normal variable of timeout index will not be kept after this function is executed
  const debounce = (inputRef, delay, func) => {
    clearTimeout(inputRef.current);
    inputRef.current = setTimeout(func, delay);
  };

  // get MIMS token and check expiry after first render
  useEffect(() => {
    MIMSToken = localStorage.getItem("MIMS-token");
    MIMSTokenExpiryTimestamp = localStorage.getItem("MIMS-token-expired");

    if (MIMSUtils.validateMIMSToken(MIMSToken, MIMSTokenExpiryTimestamp))
      return;

    // call function to generate MIMSToken again.
    generateMIMSToken();
  }, []);

  // cancel drug list popup when click outside of the popup
  useEffect(() => {
    const handleClickOutside = event => {
      if (
        isShowDrugList &&
        drugListRef.current &&
        !drugListRef.current.contains(event.target)
      ) {
        setDrugList([]);
        setIsShowDrugList(false);
      }
    };

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Unbind the event listener on clean up
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [drugListRef]);

  useEffect(() => {
    if (!formik) return;

    const { drugdata } = formik.values;

    if (!drugdata) {
      clearTimeout(drugdbInputRef.current);
      setIsShowDrugList(false);
      setDrugList([]);
      resetFieldsOfProductDetails();
      return;
    }

    if (isDrugPrefilled || isDrugManuallyInput) return;

    if (drugdata.length < 3) {
      clearTimeout(drugdbInputRef.current);
      setIsShowDrugList(false);
      setDrugList([]);
      return;
    }

    // the first param must be a object, otherwise
    debounce(drugdbInputRef, 500, () => {
      // check is MIMSToken valid.
      // If not valid, generate MIMS token again, in async way, i.e.won't wait for response before execute other commands in this func
      if (!MIMSUtils.validateMIMSToken(MIMSToken, MIMSTokenExpiryTimestamp))
        generateMIMSToken();

      // send request to search drugs
      setApiCallParams({
        reqType: "GET",
        reqUrl: `${getProductsByIngredientApiRoute}/${drugdata}/${MIMSToken}`,
        successCallback: res => {
          let drugListTemp = [];
          const drugSearchResByIngredient = res.data.data;
          // drugListTemp.push({
          //   productId: "manually_enter",
          //   productName: "Manually Enter Drug Information"
          // });

          if (
            drugSearchResByIngredient &&
            drugSearchResByIngredient.length > 0 &&
            typeof drugSearchResByIngredient[0] !== "string"
          ) {
            drugListTemp.push({
              productId: "ingredient",
              productName: "------ Search Result by Active Ingredient ------"
            });
            drugListTemp = drugListTemp.concat(drugSearchResByIngredient);
          }

          setApiCallParams({
            reqType: "GET",
            reqUrl: `${getProductsByBrandApiRoute}/${formik.values.drugdata}/${MIMSToken}`,
            successCallback: res => {
              const drugSearchResByBrand = res.data.data;

              if (
                drugSearchResByBrand &&
                drugSearchResByBrand.length > 0 &&
                typeof drugSearchResByBrand[0] !== "string"
              ) {
                drugListTemp.push({
                  productId: "brand",
                  productName: "------ Search Result by Brand ------"
                });
                drugListTemp = drugListTemp.concat(drugSearchResByBrand);
              }

              setDrugList(drugListTemp);
              setIsShowDrugList(true);
            },
            failureCallback: err => {}
          });
        },
        failureCallback: err => {}
      });
    });
  }, [formik.values.drugdata]);

  // get drug product details by productId from MIMS API
  useEffect(() => {
    if (Object.keys(selectedDrug).length === 0) return;

    setIsProcessing(true);
    setApiCallParams({
      reqType: "GET",
      reqUrl: `${getDrugProductDetailsByIdApiRoute}/${selectedDrug.productId}/${MIMSToken}`,
      successCallback: res => {
        setIsProcessing(false);
        if (res.data && res.data.data) {
          prefillFormByDrugProductDetails(res.data.data);
        }
      },
      failureCallback: err => {
        setIsProcessing(false);
      }
    });
  }, [selectedDrug]);

  // set PBS change
  useEffect(() => {
    // if (!formik.values.drugdata) return;

    if (!formik.values.PBS) {
      if (!formik.values.pbsCode) {
        clearPBSData();
        return;
      }
      cachePBSDetails();
    } else {
      if (Object.keys(prescriptionDataCache).length === 0) return;
      restorePBSDetails();
    }
  }, [formik.values.PBS]);

  // set PBSCode field
  useEffect(() => {
    if (PBSCodeSelect.length <= 1) return;

    clearPBSData();
    const code = formik.values.pbsCode.trim().split(" ")[0];
    getPBSDetailsFromMIMS(code);
  }, [formik.values.pbsCode]);

  // handle change of isIncludeBrandName
  useEffect(() => {
    if (formik.values.isIncludeBrandName) {
      if (AIPStatus === "LMBC" || AIPStatus === "NONE") {
        formik.values.drugName = ingredient + " (" + brandName + ")";
      }

      if (AIPStatus === "LEMI") {
        formik.values.drugName = brandName;
      }
    } else {
      if (formik.values.drugName) {
        formik.values.drugName = ingredient;
      }
    }
    setRefreshFlag(flag => !flag);
  }, [formik.values.isIncludeBrandName]);

  // get MIMS token and check expiry
  const generateMIMSToken = () => {
    setIsProcessing(true);
    setApiCallParams({
      reqType: "GET",
      reqUrl: accessMIMSTokenApiRoute,
      successCallback: res => {
        setIsProcessing(false);
        MIMSToken = res.data.data.access_token;
        MIMSTokenExpiryTimestamp = MIMSUtils.setMIMSTokenExpiredTime(
          res.data.data.expires_in
        );
        localStorage.setItem("MIMS-token", MIMSToken);
        localStorage.setItem("MIMS-token-expired", MIMSTokenExpiryTimestamp);
      },
      failureCallback: err => {
        setIsProcessing(false);
        console.error(err);
        // setModalText(
        //   "Something wrong with MIMS token. Please try to reload page again"
        // );
        // setShowTextModal(true);
      }
    });
  };

  const selectDrug = drug => {
    if (drug.productName === "Manually Enter Drug Information") {
      setIsDrugManuallyInput(true);
      setIsDrugPrefilled(false);
      setIsManuallyEnterQty(true);
    } else {
      formik.values.drugdata = drug.productName || "";
      setIsDrugPrefilled(true);
      setIsManuallyEnterQty(false);
      setSelectedDrug(drug);
    }

    setDrugList([]);
    setIsShowDrugList(false);
  };

  const prefillFormByDrugProductDetails = drugProductDetails => {
    // handle "S8" drug
    if (
      drugProductDetails.poisonClassification &&
      drugProductDetails.poisonClassification.poisonClasses
    ) {
      const poisonClasses =
        drugProductDetails.poisonClassification.poisonClasses;
      if (poisonClasses.length > 0 && poisonClasses[0] === "S8") {
        setIsPoisonClassS8(true);
        return;
      }
    }

    const productName = drugProductDetails.productName;

    // handle extemporaneous drug
    let acgName = "";

    if (drugProductDetails.acgs[0] && drugProductDetails.acgs[0].acgName) {
      acgName = drugProductDetails.acgs[0].acgName;
    }

    if (extemporaneousDrugList && extemporaneousDrugList.length > 0) {
      if (extemporaneousDrugList.indexOf(productName) > -1) {
        setIsExtemporaneousDrug(true);
        return;
      }
    }

    if (discontinuedDrugList && discontinuedDrugList.length > 0) {
      if (discontinuedDrugList.indexOf(productName) > -1) {
        setIsDiscontinuedDrug(true);
        return;
      }
    }

    if (outOfStockDrugError && outOfStockDrugError.length > 0) {
      const outOfStockIndex = outOfStockDrugError.map(e => e.drug).indexOf(productName);
      console.log("Hey here: ", outOfStockDrugError, productName, outOfStockIndex);
      if (outOfStockIndex > -1) {
        setIsOutOfStockDrug(outOfStockDrugError[outOfStockIndex].message);
        return;
      }
    }

    let specialDrugType = "";

    // handle S4 warning drug
    if (S4WarningDrugList && S4WarningDrugList.length > 0) {
      const S4WarningDrugListLength = S4WarningDrugList.length;

      if (productName) {
        for (var i = 0; i < S4WarningDrugListLength; i++) {
          var index = productName.indexOf(S4WarningDrugList[i]);
          if (index > -1) {
            specialDrugType = "S4_WARNING";
            break;
          }
        }
      }

      if (acgName && specialDrugType !== "S4_WARNING") {
        for (var i = 0; i < S4WarningDrugListLength; i++) {
          var index = acgName.indexOf(S4WarningDrugList[i]);
          if (index > -1) {
            specialDrugType = "S4_WARNING";
            break;
          }
        }
      }
    }

    // handle S4 disabled drug
    if (S4DisabledDrugList && S4DisabledDrugList.length > 0) {
      const S4DisabledDrugListLength = S4DisabledDrugList.length;

      if (productName) {
        for (var i = 0; i < S4DisabledDrugListLength; i++) {
          var index = productName.indexOf(S4DisabledDrugList[i]);
          if (index > -1) {
            specialDrugType = "S4_DISABLED";
            break;
          }
        }
      }

      if (acgName && specialDrugType !== "S4_DISABLED") {
        for (var i = 0; i < S4DisabledDrugListLength; i++) {
          var index = acgName.indexOf(S4DisabledDrugList[i]);
          if (index > -1) {
            specialDrugType = "S4_DISABLED";
            break;
          }
        }
      }
    }

    if (APSPrescriberDrugList && APSPrescriberDrugList.length > 0) {
      const foundDrug = _.find(APSPrescriberDrugList, function (o) {
        const isProductNameIndluded = productName ? productName.toLowerCase().includes(o) : false;
        const isACGNameIncluded = (acgName ? acgName.toLowerCase().includes(o) : false);
        return (isProductNameIndluded || isACGNameIncluded);
      });
      if (foundDrug) {
        specialDrugType = "APS_DRUG_WARNING";
      }
    }

    // handle drug which is containing "Codeine" but not in S4D or S4W list
    if (!specialDrugType && acgName.includes("Codeine"))
      specialDrugType = "S4_WARNING";

    setSpecialDrugType(specialDrugType);

    if (specialDrugType === "S4_DISABLED") return;

    if (specialDrugType === "APS_DRUG_WARNING") {
      return;
    }

    //handle drug which is containing "isotretinoin"
    let isIsotretinoin = false;

    if (isotretinoinDrugList && isotretinoinDrugList.length > 0) {
      const isotretinoinDrugListLength = isotretinoinDrugList.length;

      if (productName) {
        for (let i = 0; i < isotretinoinDrugListLength; i++) {
          let index = productName
            .toLowerCase()
            .indexOf(isotretinoinDrugList[i]);

          if (index > -1) {
            isIsotretinoin = true;
            break;
          }
        }
        if (isIsotretinoin) {
          setIsIsotretinoinDrugList(true);
          return;
        }
      }

      if (acgName) {
        for (let i = 0; i < isotretinoinDrugListLength; i++) {
          let index = acgName.toLowerCase().indexOf(isotretinoinDrugList[i]);
          if (index > -1) {
            isIsotretinoin = true;
            break;
          }
        }
        if (isIsotretinoin) {
          setIsIsotretinoinDrugList(true);
          return;
        }
      }
    }

    //handle drug which is containing "isotretinoin"
    let isInPersonGPDrug = false;

    if (inPersonGPDrugList && inPersonGPDrugList.length > 0) {
      const inPersonGPDrugListLength = inPersonGPDrugList.length;

      if (productName) {
        for (let i = 0; i < inPersonGPDrugListLength; i++) {
          let index = productName.toLowerCase().indexOf(inPersonGPDrugList[i]);

          if (index > -1) {
            isInPersonGPDrug = true;
            break;
          }
        }
        if (isInPersonGPDrug) {
          setIsInPersonGPDrugList(true);
          return;
        }
      }

      if (acgName) {
        for (let i = 0; i < inPersonGPDrugListLength; i++) {
          let index = acgName.toLowerCase().indexOf(inPersonGPDrugList[i]);
          if (index > -1) {
            isInPersonGPDrug = true;
            break;
          }
        }
        if (isInPersonGPDrug) {
          setIsInPersonGPDrugList(true);
          return;
        }
      }
    }

    // handle drug which are in COVID 19 Blocked Drug List
    let isCovid19Drug = false;

    if (covid19BlockedDrugList && covid19BlockedDrugList.length > 0) {
      const covid19DrugListLength = covid19BlockedDrugList.length;

      if (productName) {
        for (let i = 0; i < covid19DrugListLength; i++) {
          let index = productName.toLowerCase().indexOf(covid19BlockedDrugList[i]);

          if (index > -1) {
            isCovid19Drug = true;
            break;
          }
        }
        if (isCovid19Drug) {
          setIsCOVID19BlockedDrugList(true);
          return;
        }
      }

      if (acgName) {
        for (let i = 0; i < covid19DrugListLength; i++) {
          let index = acgName.toLowerCase().indexOf(covid19BlockedDrugList[i]);
          if (index > -1) {
            isCovid19Drug = true;
            break;
          }
        }
        if (isCovid19Drug) {
          setIsCOVID19BlockedDrugList(true);
          return;
        }
      }
    }

    // handle drug which are in irregular qty Drug List
    let isirregularDrug = false;

    if (irregularQtyDrugList && irregularQtyDrugList.length > 0) {
      const irregularQtyDrugListLength = irregularQtyDrugList.length;

      if (productName) {
        for (let i = 0; i < irregularQtyDrugListLength; i++) {
          let index = productName.toLowerCase().indexOf(irregularQtyDrugList[i]);

          if (index > -1) {
            isirregularDrug = true;
            break;
          }
        }
        if (isirregularDrug) {
          setIsIrregularQtyDrugList(true);
          return;
        }
      }

      if (acgName) {
        for (let i = 0; i < irregularQtyDrugListLength; i++) {
          let index = acgName.toLowerCase().indexOf(irregularQtyDrugList[i]);
          if (index > -1) {
            isirregularDrug = true;
            break;
          }
        }
        if (isirregularDrug) {
          setIsIrregularQtyDrugList(true);
          return;
        }
      }
    }

    // set drug name
    let MIMSBrandName =
      drugProductDetails.amt &&
      drugProductDetails.amt[0] &&
      drugProductDetails.amt[0].tpName
        ? drugProductDetails.amt[0].tpName
        : drugProductDetails.brand
        ? drugProductDetails.brand.brandName
        : "";
    let MIMSIngredient =
      drugProductDetails.acgs &&
      drugProductDetails.acgs[0] &&
      drugProductDetails.acgs[0].acgName
        ? drugProductDetails.acgs[0].acgName
        : "";
    let drugName = MIMSIngredient;

    setBrandName(MIMSBrandName);
    setIngredient(MIMSIngredient);

    /* // remove as AIP rules integrated 
    if (multipleBrandNameDrugList && multipleBrandNameDrugList.length > 0) {
      if (
        multipleBrandNameDrugList.indexOf(drugProductDetails.brand.brandName) >
        -1
      ) {
        drugName = drugProductDetails.productName;
      } else {
        drugName = drugProductDetails.brand.brandName;
      }
    } else {
      drugName = drugProductDetails.brand.brandName;
    }
    */

    // handle "Include Brand Name on Prescription" is ticked
    if (formik.values.isIncludeBrandName) {
      drugName = MIMSIngredient + " (" + MIMSBrandName + ")";
    }

    // if doctor select combination pack then we will have multiple drug names and multiple strengths
    // updated on 30 July 2024
    let isCombinationPack = (productName.toLowerCase().includes('combination pack') || productName.toLowerCase().includes('combo pack'));
    if (drugProductDetails.acgs.length > 1 && isCombinationPack) {
      drugName = '';
      drugProductDetails.acgs.forEach((drug, index) => {
        drugName = drugName + drug.acgName;
        if (index < drugProductDetails.acgs.length - 1) {
          drugName = drugName + '/';
        }
      })
    }

    // apply rules of AIP
    let MIMSAIPStatus = "NONE";

    if (drugProductDetails.aip) {
      if (drugProductDetails.aip.lmbc === true) {
        MIMSAIPStatus = "LMBC";
        if (!formik.values.isIncludeBrandName) {
          formik.values.isIncludeBrandName = true;
          drugName = drugName + " (" + MIMSBrandName + ")";
        }
      }

      if (drugProductDetails.aip.lemi === true) {
        MIMSAIPStatus = "LEMI";
        if (!formik.values.isIncludeBrandName) {
          formik.values.isIncludeBrandName = true;
        }
        drugName = MIMSBrandName;
      }
    }

    // if (productName.toLowerCase().includes("combination pack")) {
    //   formik.values.drugName = productName;
    // } else {
    //   formik.values.drugName = drugName;
    // }

    // updated on 30 July 2024 - If combination pack is selected then we will input multiple drug names in strength and drug name will be product name for display purpose and strength will be drug name(s)
    formik.values.drugName = isCombinationPack ? productName : drugName;

    setAIPStatus(MIMSAIPStatus);

    // set routeAdministration, formType, strength, moleculeName
    const routeAdministration =
      drugProductDetails.roas && drugProductDetails.roas[0];
    let formType =
      drugProductDetails.productPacks[0].productPackItems[0].dosageForm;
    let strength = "";
    let moleculeName = "";

    if (
      drugProductDetails.vis.length > 0 &&
      drugProductDetails.vis[0].molecules
    ) {
      const molecules = drugProductDetails.vis[0].molecules;
      molecules.forEach((item, index) => {
        if (index === 0) {
          strength =
            item.moleculeStrength +
            (item.moleculeStrength === "0" ? "" : item.moleculeStrengthUnit);
          moleculeName = item.moleculeName;
        } else {
          strength =
            strength +
            " / " +
            item.moleculeStrength +
            (item.moleculeStrength === "0" ? "" : item.moleculeStrengthUnit);
          moleculeName = moleculeName + " + " + item.moleculeName;
        }
      });
    } else {
      strength = "-";
    }

    if (isCombinationPack) {
      strength = drugName; // we will have multiple drugnames here
      formType = "Combo Pack";
    }

    formik.values.formType = formType;
    formik.values.strength = strength;
    setRouteAdministration(routeAdministration);
    setMoleculeName(moleculeName);

    // handle manually input MedQty
    const drugProductPacks = drugProductDetails.productPacks;
    let medQuantity;
    let medQuantityCopy;
    let minMedQuantity;
    let medQuantitySelectWithManualInput = [];
    let medQuantitySelect = [];

    if (drugProductPacks && drugProductPacks.length === 1) {
      medQuantity = MIMSUtils.getQuantityOfMedicationText(
        drugProductPacks[0].productPackName
      );
      medQuantityCopy = medQuantity;

      if (medQuantity.includes("x")) {
        minMedQuantity = medQuantity.split("x")[1].trim();
      } else {
        minMedQuantity = medQuantity;
      }
      // medQuantitySelectWithManualInput = [medQuantity, "Manually Enter Qty"];
      medQuantitySelectWithManualInput = [medQuantity];
    } else {
      drugProductPacks.forEach((item, index) => {
        medQuantitySelect.push(
          MIMSUtils.getQuantityOfMedicationText(item.productPackName)
        );
      });
      medQuantitySelect = MIMSUtils.removeDuplicate(medQuantitySelect);
      if (medQuantitySelect.length === 1) {
        medQuantity = medQuantitySelect[0];
        medQuantityCopy = medQuantity;
        if (medQuantity.includes("x")) {
          minMedQuantity = medQuantity.split("x")[1].trim();
        } else {
          minMedQuantity = medQuantity;
        }
        medQuantitySelect = [];
        medQuantitySelectWithManualInput = [];
        // medQuantitySelectWithManualInput = [medQuantity, "Manually Enter Qty"];
        medQuantitySelectWithManualInput = [medQuantity];
      } else {
        minMedQuantity = MIMSUtils.getMinValueFromArray(medQuantitySelect);
        medQuantitySelectWithManualInput = [];
        medQuantitySelectWithManualInput = medQuantitySelect.slice();
        // medQuantitySelectWithManualInput.push("Manually Enter Qty");
      }
    }

    // set medQuantitySelectWithManualInput to Formik
    formik.values.medQuantity = medQuantitySelectWithManualInput[0];

    setMedQuantityCopy(medQuantityCopy);
    setMinMedQuantity(minMedQuantity);
    setMedQuantitySelect(medQuantitySelect);
    setMedQuantitySelectWithManualInput(medQuantitySelectWithManualInput);

    // check if it is PBS drug
    if (drugProductDetails.pbs && drugProductDetails.pbs.length > 0) {
      const PBSCodesLength = drugProductDetails.pbs.length;
      const PBSManufacturerCode =
        drugProductDetails.pbs[0].pbsManufacturerCodes[0];
      let PBSCodeList = [];

      formik.values.pbsManuCode = PBSManufacturerCode;

      for (var i = 0; i < PBSCodesLength; i++) {
        PBSCodeList.push(drugProductDetails.pbs[i].pbsCode);
      }
      if (PBSCodeList && PBSCodeList.length === 1) {
        formik.values.pbsCode = PBSCodeList[0];

        getPBSDetailsFromMIMS(PBSCodeList[0]);
      } else {
        PBSCodeList.sort();
        getMultiplePBSCodeAndText(PBSCodeList);
      }
    }
  };

  // get PBSDetails From MIMS API
  const getPBSDetailsFromMIMS = PBSCodeWithoutText => {
    setIsProcessing(true);
    promisePBSDetailsRequest(PBSCodeWithoutText)
      .then(res => {
        setIsProcessing(false);
        let PBSDetails = res;

        if (!PBSDetails) return;

        let PBSCodeForErx;
        let PBSManufacturerCode;
        let RPBS;
        let RPBSPrefilled;
        let PBS;
        let PBSPrefilled;
        let PBSCodeTemp;
        let blockedPBSType;

        if (PBSDetails.pbsType !== "PBS/RPBS" && PBSDetails.pbsType !== "PBS") {
          PBSCodeForErx = formik.values.pbsCode;
          PBSManufacturerCode = "";
          RPBS = false;
          RPBSPrefilled = false;
          PBS = false;
          PBSPrefilled = false;
          PBSCodeTemp = "";
          blockedPBSType = "";

          if (PBSDetails.pbsType === "RPBS") {
            if (PBSCodeSelect && PBSCodeSelect.length > 0) {
              let index = PBSCodeSelect.indexOf(PBSCodeForErx.trim());

              if (index > -1) {
                let newElement =
                  PBSCodeSelect[index].trim().split(" ")[0] +
                  " " +
                  "RPBS Only (Private Script)";
                PBSCodeSelect.splice(index, 1, newElement);
                PBSCodeTemp = newElement;
              }
            }
          } else {
            blockedPBSType = PBSDetails.pbsType;
          }

          formik.values.pbsCode = PBSCodeTemp;
          formik.values.PBS = PBS;
          formik.values.pbsManuCode = PBSManufacturerCode;
          setPBSCodeSelect(PBSCodeSelect);
          setPBSCodeForErx(PBSCodeForErx);
          setRPBS(RPBS);
          setRPBSPrefilled(RPBSPrefilled);
          setPBSPrefilled(PBSPrefilled);
          setBlockedPBSType(blockedPBSType);

          return;
        } else {
          PBS = true;
          PBSPrefilled = true;
          RPBS = false;
          RPBSPrefilled = false;

          formik.values.PBS = PBS;

          setPBSPrefilled(PBSPrefilled);
          setRPBS(RPBS);
          setRPBSPrefilled(RPBSPrefilled);
        }

        let maxNumberOfRepeats = PBSDetails.repeats;
        let maxQtyUnits = PBSDetails.maxQtyUnits;
        let isManuallyEnterQty = false;
        formik.values.numberOfRepeat = maxNumberOfRepeats;
        setMaxNumberOfRepeats(maxNumberOfRepeats);
        setMaxQtyUnits(maxQtyUnits);
        setIsManuallyEnterQty(isManuallyEnterQty);

        let medQuantitySelectFromPBSDetails;
        let minMedQuantity;

        if (PBSDetails.pbsBrands && PBSDetails.pbsBrands.length > 0) {
          PBSManufacturerCode =
            formik.values.pbsManuCode ||
            PBSDetails.pbsBrands[0].manufacturerCode;
          const medQuantityFromPBSDetails = MIMSUtils.getMedQuantityFromPBSDetails(
            PBSDetails.pbsBrands
          );
          medQuantitySelectFromPBSDetails =
            medQuantityFromPBSDetails.medQuantitySelectFromPBSDetails;
          minMedQuantity = medQuantityFromPBSDetails.minMedQuantity;

          formik.values.pbsManuCode = PBSManufacturerCode;

          setMinMedQuantity(minMedQuantity);
          setMedQuantitySelectFromPBSDetails(medQuantitySelectFromPBSDetails);
        }

        if (
          maxQtyUnits &&
          maxQtyUnits.length > 0 &&
          maxQtyUnits >= minMedQuantity
        ) {
          formik.values.medQuantity = "";

          // value of medQuantitySelectFromPBSDetails, minMedQuantity, maxQtyUnits is set by useState in async way, so pass them to function is necessary
          handleMaxQtyUnits(
            medQuantitySelectFromPBSDetails,
            minMedQuantity,
            maxQtyUnits
          );
        }

        const PBSRestrictions = PBSDetails.restrictions;
        let authorityRequiredPBS;
        let restrictionList = [];

        if (PBSRestrictions.length === 0) {
          authorityRequiredPBS = false;
        } else {
          restrictionList = MIMSUtils.handleRestrictionText(PBSRestrictions);
          const PBSRestrictionType = PBSRestrictions[0].restrictionType;

          if (
            PBSRestrictionType === "Unrestricted" ||
            PBSRestrictionType === "Restricted"
          ) {
            authorityRequiredPBS = false;
          } else {
            authorityRequiredPBS = true;

            if (PBSRestrictionType === "Streamlined authority") {
              let APN = "";
              let isAPNRequired = false;
              let SAC = "";
              let SACSelect = [];

              if (PBSRestrictions.length === 1) {
                let streamlinedText = MIMSUtils.getStreamlinedText(
                  PBSRestrictions[0].restrictionPreview
                );
                SAC = PBSRestrictions[0].streamlinedCode + streamlinedText;
              } else {
                PBSRestrictions.forEach((value, key) => {
                  if (
                    value.streamlinedCode &&
                    value.streamlinedCode.length > 0
                  ) {
                    SACSelect.push(
                      value.streamlinedCode +
                        MIMSUtils.getStreamlinedText(value.restrictionPreview)
                    );
                  }
                });
              }

              formik.values.SAC = SAC;
              formik.values.APN = APN;
              setAPN(APN);
              setIsAPNRequired(isAPNRequired);
              setSAC(SAC);
              setSACSelect(SACSelect);
            }

            if (
              PBSRestrictionType === "Online authority required" ||
              PBSRestrictionType === "Written authority required"
            ) {
              let isAPNRequired = true;
              let SAC = "";
              let SACSelect = [];

              formik.values.SAC = SAC;
              setIsAPNRequired(isAPNRequired);
              setSAC(SAC);
              setSACSelect(SACSelect);
            }
          }
        }

        formik.values.authorityRequiredPBS = authorityRequiredPBS;
        setRestrictionList(restrictionList);
        setAuthorityRequiredPBS(authorityRequiredPBS);
      })
      .catch(err => {
        console.error("getPBSDetailsFromMIMS err", err);
        setIsProcessing(false);
      });
  };

  const getMultiplePBSCodeAndText = async PBSCodeList => {
    // create array of promise request
    const promiseRequestArr = PBSCodeList.map(item =>
      promisePBSDetailsRequest(item)
    );

    // deal with request array by Promise.all
    setIsProcessing(true);
    Promise.all(promiseRequestArr)
      .then(res => {
        setIsProcessing(false);
        let PBSCodeSelect = [];

        res.forEach((data, index) => {
          let PBSCode = data.pbsCode;
          let prescriberTypes = data.prescriberTypes;

          if (prescriberTypes.indexOf("MP") > -1) {
            let PBSDetailsRestrictions = data.restrictions;

            if (PBSDetailsRestrictions) {
              if (PBSDetailsRestrictions.length === 0) {
                PBSCode = PBSCode + " " + "Not Restricted";
              }
              if (
                PBSDetailsRestrictions.length > 0 &&
                PBSDetailsRestrictions[0].restrictionType === "Unrestricted"
              ) {
                PBSCode = PBSCode + " " + "Unrestricted";
              }
              if (
                PBSDetailsRestrictions.length > 0 &&
                PBSDetailsRestrictions[0].restrictionType === "Restricted"
              ) {
                PBSCode = PBSCode + " " + "Restricted";
              }
              if (
                PBSDetailsRestrictions.length > 0 &&
                PBSDetailsRestrictions[0].restrictionType ===
                  "Streamlined authority"
              ) {
                PBSCode = PBSCode + " " + "Streamlined Authority Code";
              }
              if (
                PBSDetailsRestrictions.length > 0 &&
                PBSDetailsRestrictions[0].restrictionType ===
                  "Online authority required"
              ) {
                PBSCode = PBSCode + " " + "Authority Approval Number";
              }
              if (
                PBSDetailsRestrictions.length > 0 &&
                PBSDetailsRestrictions[0].restrictionType ===
                  "Written authority required"
              ) {
                PBSCode = PBSCode + " " + "Authority Approval Number";
              }
              PBSCodeSelect.push(PBSCode);
            }
          }
        });

        if (PBSCodeSelect.length === 1) {
          let PBSCode = PBSCodeSelect[0].trim().split(" ")[0];
          formik.values.pbsCode = PBSCode;

          getPBSDetailsFromMIMS(PBSCode);
        } else {
          formik.values.pbsCode = "";
          setPBSCodeSelect(PBSCodeSelect);
        }
      })
      .catch(err => {
        setIsProcessing(false);
        console.error("Promise err", err);
      });
  };

  // create promise of PBSDetails API request for each PBS code
  const promisePBSDetailsRequest = PBSCode => {
    return new Promise((resolve, reject) => {
      setApiCallParams({
        reqType: "GET",
        reqUrl: `${getDrugPBSDetailsByPBSCodeApiRoute}/${PBSCode}/${MIMSToken}`,
        successCallback: res => {
          if (res.data && res.data.data) {
            resolve(res.data.data);
          } else {
            resolve({});
          }
        },
        failureCallback: err => {
          reject(err);
        }
      });
    });
  };

  const handleMaxQtyUnits = (
    medQuantitySelectFromPBSDetails,
    minMedQuantity,
    maxQtyUnits
  ) => {
    let medQuantitySelectOnMaxQtyUnits = [];

    if (
      medQuantitySelectFromPBSDetails &&
      medQuantitySelectFromPBSDetails.length > 0
    ) {
      let medQuantitySelectWithManualInput = [];

      if (medQuantitySelectFromPBSDetails[0].includes("x")) {
        medQuantitySelectOnMaxQtyUnits = medQuantitySelectFromPBSDetails;
        medQuantitySelectWithManualInput = medQuantitySelectOnMaxQtyUnits.slice();
        // medQuantitySelectWithManualInput.push("Manually Enter Qty");
        medQuantitySelectWithManualInput = MIMSUtils.removeDuplicate(
          medQuantitySelectWithManualInput
        );
      } else {
        let intMinMedQuantity = parseInt(minMedQuantity);
        let intMaxQtyUnits = parseInt(maxQtyUnits);

        for (let i = 1; i <= intMaxQtyUnits; i++) {
          if (i % intMinMedQuantity === 0) {
            medQuantitySelectOnMaxQtyUnits.push(i);
          }
        }

        medQuantitySelectWithManualInput = medQuantitySelectOnMaxQtyUnits.slice();
        // medQuantitySelectWithManualInput.push("Manually Enter Qty");
        medQuantitySelectWithManualInput = MIMSUtils.removeDuplicate(
          medQuantitySelectWithManualInput
        );
      }

      formik.values.medQuantity = medQuantitySelectWithManualInput[0];
      setMedQuantitySelectWithManualInput(medQuantitySelectWithManualInput);
    }

    // get the max quantity of medication from selection list to limit the manual input
    if (medQuantitySelectOnMaxQtyUnits.length > 0) {
      // get the last element, change it to number, keep it, when un-tick PBS cache it
      let lastIndex = medQuantitySelectOnMaxQtyUnits.length - 1;
      let maxQuantityOfMed = MIMSUtils.translateMedQuantityToNumber(
        medQuantitySelectOnMaxQtyUnits[lastIndex]
      );

      setMaxQuantityOfMed(maxQuantityOfMed);
    }

    if (medQuantitySelectOnMaxQtyUnits.length === 1) {
      let medQuantity = medQuantitySelectOnMaxQtyUnits[0];
      medQuantitySelectOnMaxQtyUnits = [];

      formik.values.medQuantity = medQuantity;
    }

    setMedQuantitySelectOnMaxQtyUnits(medQuantitySelectOnMaxQtyUnits);
  };

  const resetFieldsOfProductDetails = () => {
    prescriptionDataCache = {};

    formik.values.pbsCode = "";
    formik.values.PBS = false;
    formik.values.pbsManuCode = "";
    formik.values.drugName = "";
    formik.values.strength = "";
    formik.values.formType = "";
    formik.values.dose = "";
    formik.values.frequency = "";
    formik.values.withFood = "";
    formik.values.emptyStomach = "";
    formik.values.medQuantity = "";
    formik.values.numberOfRepeat = "";
    formik.values.authorityRequiredPBS = false;
    formik.values.SAC = "";
    formik.values.APN = "";
    formik.values.isIncludeBrandName = false;

    setIsDrugManuallyInput(false);
    setIsDrugPrefilled(false);
    setSelectedDrug({});
    setPBSPrefilled(false);
    setPBSCodeSelect([]);
    setMedQuantityCopy("");
    setMedQuantitySelect([]);
    setMedQuantitySelectWithManualInput([]);
    setMinMedQuantity("");
    setMaxQtyUnits("");
    setMaxQuantityOfMed(99999999);
    setMedQuantitySelectOnMaxQtyUnits([]);
    setIsManuallyEnterQty(false);
    setIsPoisonClassS8(false);
    setIsExtemporaneousDrug(false);
    setSpecialDrugType("");
    setBlockedPBSType("");
    setRestrictionList([]);
    setMaxNumberOfRepeats(99999999);
    setAuthorityRequiredPBS(false);
    setSAC("");
    setSACSelect([]);
    setAPN("");
    setIsAPNRequired(false);
    setRouteAdministration("");
    setMoleculeName("");
    setPBSCodeForErx("");
    setMedQuantitySelectFromPBSDetails([]);
    setIsDiscontinuedDrug(false);
    setIsIsotretinoinDrugList(false);
    setIsInPersonGPDrugList(false);
    setIsCOVID19BlockedDrugList(false);
    setIsIrregularQtyDrugList(false);
    setIsOutOfStockDrug(false);

    setBrandName("");
    setIngredient("");
    setAIPStatus("NONE");
  };

  const clearPBSData = () => {
    // setPBS(false);
    setRestrictionList([]);
    setMaxNumberOfRepeats(99999999);
    formik.values.numberOfRepeat = "";
    formik.values.authorityRequiredPBS = false;
    setAuthorityRequiredPBS(false);
    formik.values.SAC = "";
    setSAC("");
    setSACSelect([]);
    formik.values.APN = "";
    setAPN("");
    setIsAPNRequired(false);
    setMaxQuantityOfMed(99999999);
    setBlockedPBSType("");
    setMedQuantitySelectWithManualInput([]);
  };

  const cachePBSDetails = () => {
    setPBSCodeForErx(formik.values.pbsCode);

    prescriptionDataCache.pbsCode = formik.values.pbsCode;
    prescriptionDataCache.PBSCodeSelect = PBSCodeSelect;
    prescriptionDataCache.maxNumberOfRepeats = maxNumberOfRepeats;
    prescriptionDataCache.authorityRequiredPBS =
      formik.values.authorityRequiredPBS;
    prescriptionDataCache.SAC = formik.values.SAC;
    prescriptionDataCache.APN = formik.values.APN;
    prescriptionDataCache.SACSelect = SACSelect;
    prescriptionDataCache.restrictionList = restrictionList;
    prescriptionDataCache.medQuantity = formik.values.medQuantity;
    prescriptionDataCache.medQuantitySelectOnMaxQtyUnits = medQuantitySelectOnMaxQtyUnits;
    prescriptionDataCache.medQuantitySelectWithManualInput = medQuantitySelectWithManualInput;
    prescriptionDataCache.maxQuantityOfMed = maxQuantityOfMed;

    formik.values.pbsCode = "";
    formik.values.numberOfRepeat = "";
    // setPBSCode("");
    setPBSCodeSelect([]);
    setMaxNumberOfRepeats(99999999);
    formik.values.authorityRequiredPBS = false;
    setAuthorityRequiredPBS(false);
    formik.values.SAC = "";
    setSAC("");
    setSACSelect([]);
    formik.values.APN = "";
    setAPN("");
    setRestrictionList([]);
    setMedQuantitySelectOnMaxQtyUnits([]);

    formik.values.medQuantity = medQuantityCopy;
    let medQuantitySelectWithManualInputTemp = [];
    if (medQuantityCopy) {
      // medQuantitySelectWithManualInputTemp = [
      //   medQuantityCopy,
      //   "Manually Enter Qty"
      // ];
      medQuantitySelectWithManualInputTemp = [medQuantityCopy];
    } else if (medQuantitySelect && medQuantitySelect.length > 0) {
      medQuantitySelectWithManualInputTemp = medQuantitySelect.slice();
      // medQuantitySelectWithManualInputTemp.push("Manually Enter Qty");
    }

    setMedQuantitySelectWithManualInput(medQuantitySelectWithManualInputTemp);
    setIsManuallyEnterQty(false);
    setMaxQuantityOfMed(99999999);
  };

  const restorePBSDetails = () => {
    if (Object.getOwnPropertyNames(prescriptionDataCache).length === 0) return;

    formik.values.pbsCode = prescriptionDataCache.pbsCode;
    setPBSCodeSelect(prescriptionDataCache.pbsCode);
    setPBSCodeSelect(prescriptionDataCache.PBSCodeSelect);
    setMaxNumberOfRepeats(prescriptionDataCache.maxNumberOfRepeats);
    formik.values.numberOfRepeat = prescriptionDataCache.maxNumberOfRepeats;
    formik.values.authorityRequiredPBS =
      prescriptionDataCache.authorityRequiredPBS;
    setAuthorityRequiredPBS(prescriptionDataCache.authorityRequiredPBS);
    formik.values.SAC = prescriptionDataCache.SAC;
    setSAC(prescriptionDataCache.SAC);
    formik.values.APN = prescriptionDataCache.APN;
    setAPN(prescriptionDataCache.APN);
    setSACSelect(prescriptionDataCache.SACSelect);
    setRestrictionList(prescriptionDataCache.restrictionList);
    formik.values.medQuantity = prescriptionDataCache.medQuantity;
    // setMedQuantity(prescriptionDataCache.medQuantity);
    setMedQuantitySelectOnMaxQtyUnits(
      prescriptionDataCache.medQuantitySelectOnMaxQtyUnits
    );
    setMedQuantitySelectWithManualInput(
      prescriptionDataCache.medQuantitySelectWithManualInput
    );
    setMaxQuantityOfMed(prescriptionDataCache.maxQuantityOfMed);
    setPBSCodeForErx("");
    setIsManuallyEnterQty(false);
  };

  return (
    <div className="view-ticket-container">
      {console.log("formik.values", formik.values)}

      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <form className="w-100" onSubmit={formik.handleSubmit}>
          <h4 className="mb-4">Drug Database</h4>
          <div className="row">
            <label className="col-md-2 mt-2 ml-n2 col-form-label">
              Search Drug: <span className="error">*</span>
            </label>
            <div className="col-md-12 ml-n2 mb-3 position-relative">
              <SearchInput
                // // either id or name must exist when onChange, onBlur, value are used
                // id="drugdata"
                // name="drugdata"
                // onChange={formik.handleChange}
                // onBlur={formik.handleBlur}
                // value={formik.values.drugdata}

                // either id or name is not necessary when getFieldProps is used
                {...formik.getFieldProps("drugdata")}
                placeholder="Search Drug Database"
                autoComplete="off"
                className={`w-100 font-14 ${isPoisonClassS8 &&
                  "prescription-strike"} ${isExtemporaneousDrug &&
                  "prescription-strike"} ${blockedPBSType &&
                  // "prescription-strike"} ${specialDrugType === "S4_DISABLED" &&
                  "prescription-strike"} ${(specialDrugType === "S4_DISABLED" || specialDrugType === "APS_DRUG_WARNING") &&
                  "prescription-strike"} ${isDiscontinuedDrug &&
                  "prescription-strike"} ${isIsotretinoinDrugList &&
                  "prescription-strike"} ${isInPersonGPDrugList &&
                  "prescription-strike"} ${isCOVID19BlockedDrugList &&
                  "prescription-strike"} ${isIrregularQtyDrugList &&
                  "prescription-strike"} ${isOutOfStockDrug &&
                  "prescription-strike"}`}
              />
              {formik.touched.drugdata && formik.errors.drugdata && (
                <Label
                  className="small ml-1 prescription-error"
                  title={formik.errors.drugdata}
                />
              )}
              {isPoisonClassS8 && (
                <Label
                  className="small ml-1 prescription-error"
                  title="Schedule 8 Drug. Please empty the input and search another drug."
                />
              )}
              {specialDrugType === "S4_WARNING" && !blockedPBSType && (
                <Label
                  className="small ml-1 prescription-error"
                  title="Schedule 4D Drug. Caution when prescribing."
                />
              )}
              {specialDrugType === "S4_DISABLED" && (
                <Label
                  className="small ml-1 prescription-error"
                  title="Schedule 4D Drug (Special Policy). Please empty the input and search another drug."
                />
              )}
              {
                specialDrugType === "APS_DRUG_WARNING" && (
                  <Label
                    className="small ml-1 prescription-error"
                    title="APS Prescriber Number required. Please refer patient to Instant Switch."
                  />
                )
              }
              {blockedPBSType && (
                <Label
                  className="small ml-1 prescription-error"
                  title={`Schedule ${blockedPBSType} Drug. Please empty the input and search another drug.`}
                />
              )}
              {isExtemporaneousDrug && (
                <Label
                  className="small ml-1 prescription-error"
                  title="Extemporaneous Drug. Please empty the input and search another drug."
                />
              )}
              {isDiscontinuedDrug && (
                <Label
                  className="small ml-1 prescription-error"
                  title="Product Discontinued. Please empty the input and search another drug (ie. Optisulin)."
                />
              )}
              {isIsotretinoinDrugList && (
                <Label
                  className="small ml-1 prescription-error"
                  title="Not to be prescribed by GP - refer to Dermatologist (Health Legislation). Please empty the input and search another drug."
                />
              )}
              {isInPersonGPDrugList && (
                <Label
                  className="small ml-1 prescription-error"
                  title="Not to be prescribed - refer to in-person GP (Health Legislation). Please empty the input and search another drug."
                />
              )}
              {
                isCOVID19BlockedDrugList && (
                  <Label
                    className="small ml-1 prescription-error"
                    title="Not to be prescribed - refer to in-person GP (COVID-19 Health Legislation). <br /> Please empty the input and search another drug."
                  />
                )
              }
              {
                isIrregularQtyDrugList && (
                  <Label
                    className="small ml-1 prescription-error"
                    title="Irregular Quantity (Special Policy).<br /> Please empty the input and search another drug."
                  />
                )
              }
              {
                isOutOfStockDrug && (
                  <Label
                    className="small ml-1 prescription-error"
                    title={isOutOfStockDrug}
                  />
                )
              }

              <div ref={drugListRef} style={{ position: "relative" }}>
                {formik.values.drugdata &&
                  isShowDrugList &&
                  !!drugList.length && (
                    <DrugListDialog
                      drugList={drugList}
                      selectDrug={selectDrug}
                    />
                  )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 custom-chk-lbl pl-4 ml-1 mt-4">
              <ICCheckbox
                style={{
                  padding: 0,
                  paddingRight: "5px"
                }}
                name="PBS"
                disabled={isDrugPrefilled && !PBSPrefilled}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.PBS}
                inputProps={{
                  "aria-label": "PBS"
                }}
                label="PBS"
              />
              {/* <ICCheckbox
                style={{
                  padding: 0,
                  paddingRight: "5px",
                  paddingLeft: "30px"
                }}
                name="brandSubstitution"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.brandSubstitution}
                inputProps={{
                  "aria-label": "Brand Substitution Not Permitted"
                }}
                label="Brand Substitution Not Permitted"
              /> */}
              <ICCheckbox
                style={{ padding: 0, paddingRight: "5px", paddingLeft: "15px" }}
                name="isIncludeBrandName"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.isIncludeBrandName}
                inputProps={{
                  "aria-label": "Include Brand Name on Prescription"
                }}
                label="Include Brand Name on Prescription"
              />
            </div>
          </div>

          {/* <div className="form-row mt-4">
            <div className="form-group col-md-6">
              <label>PBS Code</label>
              <ICInput
                name="pbsCode"
                type="text"
                placeholder="e.g 2242B"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.pbsCode}
                error={
                  formik.touched.pbsCode && formik.errors.pbsCode ? true : false
                }
                helperText={
                  formik.touched.pbsCode && formik.errors.pbsCode
                    ? formik.errors.pbsCode
                    : ""
                }
              />
            </div>
            <div className="form-group col-md-6">
              <label>PBS Manufacturer Code</label>
              <ICInput
                name="pbsManufacturerCode"
                type="text"
                placeholder="e.g AS"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.pbsManufacturerCode}
                error={
                  formik.touched.pbsManufacturerCode &&
                  formik.errors.pbsManufacturerCode
                    ? true
                    : false
                }
                helperText={
                  formik.touched.pbsManufacturerCode &&
                  formik.errors.pbsManufacturerCode
                    ? formik.errors.pbsManufacturerCode
                    : ""
                }
              />
            </div>   
          </div> */}

          <div className="row">
            {PBSCodeSelect.length <= 1 && (
              <div className="col-sm-6 mt-4 mb-4">
                <Label className="gray ex-small" title="PBS Code" />
                <ICInput
                  id="pbsCode"
                  name="pbsCode"
                  disabled
                  className="placeholder-small  ic-input-dark-font"
                  type="text"
                  label=""
                  placeholder="Applicable to PBS Drug"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.pbsCode}
                  style={{ width: "100%" }}
                />
              </div>
            )}

            {PBSCodeSelect.length > 1 && (
              <div className="col-sm-6 mt-4 mb-4">
                <Label
                  className="gray ex-small"
                  required={true}
                  title="Select PBS Code"
                />
                <ICInput
                  id="pbsCode"
                  name="pbsCode"
                  className="placeholder-small ic-input-dark-font"
                  type="text"
                  label=""
                  select
                  required
                  placeholder="Select PBS code"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.pbsCode}
                  style={{ width: "100%" }}
                >
                  {PBSCodeSelect.map(item => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </ICInput>
                {!formik.values.pbsCode && (
                  <Label
                    className="small ml-1 prescription-error"
                    title={"PBS Code is required"}
                  />
                )}
              </div>
            )}

            <div className="col-sm-6 mt-4 mb-4">
              <Label className="gray ex-small" title="PBS Manufacturer Code" />
              <ICInput
                id="pbsManuCode"
                name="pbsManuCode"
                disabled
                className="placeholder-small ic-input-dark-font"
                type="text"
                label=""
                placeholder="Applicable to PBS Drug"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.pbsManuCode}
                style={{ width: "100%" }}
              />
            </div>
          </div>

          {restrictionList.length > 0 && (
            <div className="col-sm-12 mt-3 ml-n2 custom-chk-lbl">
              <RestrictionListView restrictionList={restrictionList} />
            </div>
          )}

          {/* <div className="col-md-12 mt-4">
            <div className="row pl-3">
              <ICCheckbox
                style={{ padding: 0 }}
                name="authReqCheckbox"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                checked={formik.values.authReqCheckbox}
                inputProps={{
                  "aria-label": "primary checkbox"
                }}
              />
              <p className="mb-0" style={{ marginLeft: "-10px" }}>
                Authority Required PBS Prescription
              </p>
            </div>
          </div> */}
          <div className="row">
            <div className="col-sm-12 mt-3 pl-3 custom-chk-lbl">
              <ICCheckbox
                name="authorityRequiredPBS"
                disabled={isDrugPrefilled || !formik.values.PBS}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.authorityRequiredPBS}
                inputProps={{
                  "aria-label": "Authority Required PBS Prescription"
                }}
                label="Authority Required PBS Prescription"
              />
            </div>
          </div>

          <div className="row">
            {isDrugPrefilled && authorityRequiredPBS && SACSelect.length === 0 && (
              <Fragment>
                {!APN && !isAPNRequired && (
                  <div className="col-sm-12 mt-2">
                    <Label
                      className="gray ex-small"
                      title="Streamlined Authority Code"
                    />
                    <ICInput
                      id="SAC"
                      name="SAC"
                      disabled={!APN && !isAPNRequired}
                      type="text"
                      className="placeholder-small ic-input-dark-font w-90"
                      label=""
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.SAC}
                      error={
                        formik.touched.SAC && formik.errors.SAC ? true : false
                      }
                      helperText={
                        formik.touched.SAC && formik.errors.SAC
                          ? formik.errors.SAC
                          : ""
                      }
                      style={{ width: "95%" }}
                    />
                    {!formik.values.SAC && (
                      <Label
                        className="small ml-1 prescription-error"
                        title={"Streamlined Authority Code is required"}
                      />
                    )}
                  </div>
                )}
              </Fragment>
            )}

            {isDrugPrefilled &&
              authorityRequiredPBS &&
              SACSelect.length > 0 &&
              !APN &&
              !isAPNRequired && (
                <div className="col-sm-12 mt-2">
                  <Label
                    className="gray ex-small"
                    title="Select Streamlined Authority Code"
                    required={true}
                  />
                  <ICInput
                    id="SAC"
                    name="SAC"
                    select
                    type="text"
                    className="placeholder-small ic-input-dark-font w-90"
                    label=""
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.SAC}
                    error={formik.errors.SAC ? true : false}
                    helperText={formik.errors.SAC ? formik.errors.SAC : ""}
                    style={{ width: "95%" }}
                  >
                    {SACSelect.map(item => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </ICInput>
                  {/* {formik.errors.SAC && <div>{formik.errors.SAC}</div>} */}
                  {/* {!formik.values.SAC && (
                    <Label
                      className="small ml-1 prescription-error"
                      title={"Streamlined Authority Code is required"}
                    />
                  )} */}
                </div>
              )}

            {isDrugPrefilled &&
              authorityRequiredPBS &&
              !SAC &&
              SACSelect.length === 0 && (
                <div className="col-sm-12 mt-2">
                  <Label
                    className="gray ex-small"
                    title="Authority Approval Number"
                    required={true}
                  />
                  <ICInput
                    id="APN"
                    name="APN"
                    type="text"
                    className="placeholder-small ic-input-dark-font"
                    label=""
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.APN}
                    error={formik.errors.APN ? true : false}
                    helperText={formik.errors.APN ? formik.errors.APN : ""}
                    style={{ width: "95%" }}
                  />
                  {!formik.values.APN && (
                    <Label
                      className="small ml-1 prescription-error"
                      title={"Authority Approval Number is required"}
                    />
                  )}
                </div>
              )}

            {!isDrugPrefilled && authorityRequiredPBS && (
              <div className="col-sm-6 mt-2">
                <Label
                  className="gray ex-small"
                  title="Streamlined Authority Code"
                />
                <ICInput
                  id="SAC"
                  name="SAC"
                  disabled={!!formik.values.APN}
                  type="text"
                  className="placeholder-small ic-input-dark-font w-90"
                  label=""
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.SAC}
                  error={formik.errors.SAC ? true : false}
                  helperText={formik.errors.SAC ? formik.errors.SAC : ""}
                  style={{ width: "95%" }}
                />
                {!formik.values.SAC && !formik.values.APN && (
                  <Label
                    className="small ml-1 prescription-error"
                    title={"One from these two fields is required"}
                  />
                )}
              </div>
            )}

            {!isDrugPrefilled && authorityRequiredPBS && (
              <div className="col-sm-6 mt-2">
                <Label
                  className="gray ex-small"
                  title="Authority Approval Number"
                />
                <ICInput
                  id="APN"
                  name="APN"
                  disabled={!!formik.values.SAC}
                  type="text"
                  className="placeholder-small ic-input-dark-font"
                  label=""
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.APN}
                  error={formik.errors.APN ? true : false}
                  helperText={formik.errors.APN ? formik.errors.APN : ""}
                  style={{ width: "95%" }}
                />
                {!formik.values.SAC && !formik.values.APN && (
                  <Label
                    className="small ml-1 prescription-error"
                    title={"One from these two fields is required"}
                  />
                )}
              </div>
            )}
          </div>

          {/* <div className="form-row mt-4">
            <div className="form-group col-md-12">
              <label>
                Drug Name <span className="error">*</span>
              </label>
              <ICInput
                name="drugName"
                type="text"
                placeholder="e.g Apropax (Paroxetine Hydrochloride)"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.drugName}
                error={
                  formik.touched.drugName && formik.errors.drugName
                    ? true
                    : false
                }
                helperText={
                  formik.touched.drugName && formik.errors.drugName
                    ? formik.errors.drugName
                    : ""
                }
              />
            </div>
          </div> */}

          <div className="row">
            <div className="col-sm-12 mt-4">
              <Label className="gray ex-small" title="Drug Name" />
              <ICInput
                id="drugName"
                name="drugName"
                disabled
                type="text"
                className="placeholder-small w-100 ic-input-dark-font"
                label=""
                // placeholder="e.g. Aropax (Paroxetine Hydrochloride)"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.drugName}
                error={
                  formik.touched.drugName && formik.errors.drugName
                    ? true
                    : false
                }
                helperText={
                  formik.touched.drugName && formik.errors.drugName
                    ? formik.errors.drugName
                    : ""
                }
              />
            </div>
          </div>

          {/* <div className="form-row mt-4">
            <div className="form-group col-md-6">
              <label>
                Strength <span className="error">*</span>
              </label>
              <ICInput
                name="strength"
                type="text"
                placeholder="e.g 20mg"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.strength}
                error={
                  formik.touched.strength && formik.errors.strength
                    ? true
                    : false
                }
                helperText={
                  formik.touched.strength && formik.errors.strength
                    ? formik.errors.strength
                    : ""
                }
              />
            </div>
            <div className="form-group col-md-6">
              <label>
                Form Type <span className="error">*</span>
              </label>
              <ICInput
                name="formType"
                type="text"
                placeholder="e.g Tablets"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.formType}
                error={
                  formik.touched.formType && formik.errors.formType
                    ? true
                    : false
                }
                helperText={
                  formik.touched.formType && formik.errors.formType
                    ? formik.errors.formType
                    : ""
                }
              />
            </div>
          </div> */}

          <div className="row">
            <div className="col-sm-6 mt-4">
              <Label className="gray ex-small" title="Strength" />
              <ICInput
                id="strength"
                name="strength"
                disabled
                type="text"
                className="placeholder-small ic-input-dark-font w-100"
                label=""
                // placeholder="e.g. 20mg"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.strength}
                error={
                  formik.touched.strength && formik.errors.strength
                    ? true
                    : false
                }
                helperText={
                  formik.touched.strength && formik.errors.strength
                    ? formik.errors.strength
                    : ""
                }
              />
            </div>

            <div className="col-sm-6 mt-4">
              <Label className="gray ex-small" title="Form Type" />
              <ICInput
                id="formType"
                name="formType"
                disabled
                type="text"
                className="placeholder-small ic-input-dark-font w-100"
                label=""
                // placeholder="e.g. Tablets"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.formType}
                error={
                  formik.touched.formType && formik.errors.formType
                    ? true
                    : false
                }
                helperText={
                  formik.touched.formType && formik.errors.formType
                    ? formik.errors.formType
                    : ""
                }
              />
            </div>
          </div>

          {/* <div className="form-row mt-4">
            <div className="form-group col-md-6">
              <label>
                Quantity of the Medication <span className="error">*</span>
              </label>
              <ICInput
                name="quantity"
                type="text"
                placeholder="e.g 30"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.quantity}
                error={
                  formik.touched.quantity && formik.errors.quantity
                    ? true
                    : false
                }
                helperText={
                  formik.touched.quantity && formik.errors.quantity
                    ? formik.errors.quantity
                    : ""
                }
              />
            </div>
            <div className="form-group col-md-6">
              <label>
                Max Number of Repeats <span className="error">*</span>
              </label>
              <ICInput
                name="noOfRepeats"
                type="text"
                placeholder="e.g Applicable to PBS Drug"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.noOfRepeats}
                error={
                  formik.touched.noOfRepeats && formik.errors.noOfRepeats
                    ? true
                    : false
                }
                helperText={
                  formik.touched.noOfRepeats && formik.errors.noOfRepeats
                    ? formik.errors.noOfRepeats
                    : ""
                }
              />
            </div>
          </div> */}

          <div className="row">
            {(!isDrugPrefilled ||
              isManuallyEnterQty ||
              medQuantitySelectWithManualInput.length <= 1) && (
              <div className="col-sm-6 mt-4">
                <Label
                  className="gray ex-small"
                  title="Quantity of the Medication"
                />

                <ICInput
                  id="medQuantity"
                  name="medQuantity"
                  disabled
                  type="number"
                  className="placeholder-small ic-input-dark-font w-100"
                  label=""
                  // placeholder="e.g. 30"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.medQuantity}
                  error={formik.errors.medQuantity ? true : false}
                  helperText={
                    formik.errors.medQuantity ? formik.errors.medQuantity : ""
                  }
                />
              </div>
            )}

            {isDrugPrefilled &&
              !isManuallyEnterQty &&
              medQuantitySelectWithManualInput.length > 1 && (
                <div className="col-sm-6 mt-4">
                  <Label
                    className="gray ex-small"
                    required={true}
                    title="Select Quantity of the Medication"
                  />

                  <ICInput
                    id="medQuantity"
                    name="medQuantity"
                    select
                    type="text"
                    label=""
                    className="placeholder-small ic-input ic-input-dark-font w-100"
                    placeholder="e.g. 30"
                    autoComplete="off"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.medQuantity}
                    error={
                      formik.touched.medQuantity && formik.errors.medQuantity
                        ? true
                        : false
                    }
                    helperText={
                      formik.touched.medQuantity && formik.errors.medQuantity
                        ? formik.errors.medQuantity
                        : ""
                    }
                  >
                    {medQuantitySelectWithManualInput.map(item => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </ICInput>
                </div>
              )}

            <div className="col-sm-6 mt-4">
              <Label className="gray ex-small" title="Max Number of Repeats" />

              <ICInput
                id="numberOfRepeat"
                name="numberOfRepeat"
                type="number"
                disabled
                className="placeholder-small ic-input-dark-font w-100"
                inputProps={{ max: maxNumberOfRepeats, min: 0 }}
                label=""
                placeholder="Applicable to PBS Drug"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.numberOfRepeat}
              />
            </div>
          </div>
        </form>
        <br />
      </div>
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />

      <Model
        useOneButton={true}
        cancelText="Okay"
        openModal={showTextModal}
        cancelEvent={() => {
          setShowTextModal(false);
          setModalText("");
        }}
        modalBodyContent={<p className="text-center mb-0">{modalText}</p>}
      />
    </div>
  );
};

export default DrugDatabasePage;
